import { m } from '@pricedrop/i18n';
import MessageSquare from 'lucide-react/dist/esm/icons/message-square';
import Plus from 'lucide-react/dist/esm/icons/plus';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useAuthModal } from '@/lib/auth-modal-context';

interface ReviewsEmptyStateProps {
  itemName: string;
  isAuthenticated: boolean;
  hasUserReviewed: boolean;
  hasDraft: boolean;
  onAddReview: () => void;
}

export default function ReviewsEmptyState({
  itemName,
  isAuthenticated,
  hasUserReviewed,
  hasDraft,
  onAddReview,
}: ReviewsEmptyStateProps) {
  const { requireAuth } = useAuthModal();

  function handleAddReview() {
    requireAuth(onAddReview, {
      title: m.auth_requireAuth_reviews_title(),
      description: m.auth_requireAuth_reviews_description(),
    });
  }

  return (
    <Card className="py-12 text-center">
      <CardContent>
        <MessageSquare className="mx-auto mb-4 h-12 w-12 text-gray-400" />
        <h3 className="mb-2 text-lg font-medium text-gray-900 dark:text-white">
          אין ביקורות עדיין
        </h3>
        <p className="mb-4 text-gray-600 dark:text-gray-400">
          היו הראשונים לחלוק את החוויה שלכם עם {itemName}
        </p>
        {!hasUserReviewed && (
          <Button onClick={isAuthenticated ? onAddReview : handleAddReview} variant="outline">
            <Plus className="me-2 h-4 w-4" />
            {hasDraft ? 'המשך כתיבת ביקורת' : 'כתבו ביקורת ראשונה'}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
